import { createContext } from 'react'

const contextPayload = {
  isPublic: undefined,
  isPrivated: undefined,
  userType: undefined,
  orgCode: undefined
}

const AuthorizationContext = createContext(contextPayload)
AuthorizationContext.displayName = 'authorization-context'

export default AuthorizationContext
